import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
  text: {
    width: undefined,
    height: '100%',
  },
});
